<template>
  <div class="table">
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item> <i class="el-icon-lx-cascades"></i> 用户管理 </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="app-container">
        <div style="margin-bottom: 20px">
          <el-input v-model="listQuery.name" placeholder="请输入账号" style="width: 200px"></el-input>
          <el-input v-model="listQuery.real_name" placeholder="请输入用户姓名" style="width: 200px; margin-left: 20px"></el-input>
          <span style="margin-left: 20px; font-size: 15px">角色：</span>
          <el-select v-model="listQuery.role" filterable placeholder="请选择">
            <el-option v-for="item in roleOptions" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
          <span style="margin-left: 20px; font-size: 15px">状态：</span>
          <el-select v-model="listQuery.user_status" filterable placeholder="请选择">
            <el-option v-for="item in statusOptions" :key="item.name" :label="item.name" :value="item.id"> </el-option>
          </el-select>
          <span style="font-size: 15px; margin-left: 20px">创建时间：</span>
          <el-date-picker
            v-model="listQuery.create_time"
            type="datetimerange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['24:00:00']"
          ></el-date-picker>

          <div style="float: right; margin: 30px 30px 20px 0">
            <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">搜索</el-button>
            <el-button class="filter-item" type="success" @click="handleCreate">添加</el-button>
            <el-button class="filter-item" type="warning" @click="handleReset">重置</el-button>
          </div>
        </div>

        <el-table border v-loading="listLoading" min-height="200" max-height="1000" :data="tableData" style="width: 100%">
          <el-table-column prop="name" label="账号" width="100" />
          <el-table-column prop="real_name" label="真实姓名" width="100" />
          <el-table-column prop="role_name" label="角色" width="100" />
          <el-table-column prop="city_flag" label="客服城市" width="100" />
          <el-table-column prop="city_name" label="具体城市" width="100" />
          <el-table-column prop="group_type" label="客服类型" width="100" />
          <el-table-column prop="mobile" label="电话" width="100" />
          <el-table-column prop="email" label="邮箱" width="150" />
          <el-table-column prop="last_login_time" label="最近登录时间" width="150" />
          <el-table-column prop="created_at" label="创建时间" width="150" />
          <el-table-column prop="user_status_name" label="状态" width="100" />
          <el-table-column label="操作" fixed="right" class-name="small-padding fixed-width" width="500">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" icon="el-icon-edit" @click="handleUpdate(scope.row)">编辑</el-button>
              <el-button type="warning" size="mini" icon="el-icon-star-off" @click="resetUserPassword(scope.row)">重置密码</el-button>
              <el-button type="primary" size="mini" @click="handleBind(scope.row)">绑定账号</el-button>
              <el-button type="info" size="mini" @click="disableAccount(scope.row)" v-if="scope.row.user_status == 1">禁用</el-button>
              <el-button type="success" size="mini" @click="disableAccount(scope.row)" v-if="scope.row.user_status == 0">恢复</el-button>
              <el-button type="danger" size="mini" @click="userDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <pagination v-show="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="userList" />

        <BindDD ref="bind"></BindDD>
        <el-dialog title="删除" center width="40%" :visible.sync="deleteShow">
          <p>确认删除此用户吗？</p>
          <div slot="footer" class="dialog-footer">
            <el-button @click="deleteShow = false">取 消</el-button>
            <el-button type="primary" @click="handleDelete">确 定</el-button>
          </div>
        </el-dialog>

        <el-dialog title="重置密码" center width="25%" :visible.sync="resetShow">
          <p>确认重置当前用户密码为123456？</p>
          <div slot="footer" class="dialog-footer">
            <el-button @click="resetShow = false">取 消</el-button>
            <el-button type="primary" @click="sureReset">确 定</el-button>
          </div>
        </el-dialog>

        <el-dialog title="状态管理" center width="25%" :visible.sync="disableShow">
          <p>{{ disabText }}</p>
          <div slot="footer" class="dialog-footer">
            <el-button @click="disableShow = false">取 消</el-button>
            <el-button type="primary" @click="sureDisable">确 定</el-button>
          </div>
        </el-dialog>

        <el-dialog title="用户管理" center width="60%" :visible.sync="dialogFormVisible">
          <el-form :model="formData" style="margin-left: 50px">
            <el-form-item label="账号" :label-width="formLabelWidth">
              <el-col :span="8">
                <el-input v-model="formData.name"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item v-show="passwordVisible" label="密码" :label-width="formLabelWidth">
              <el-col :span="8">
                <el-input v-model="formData.password"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="真实姓名" :label-width="formLabelWidth">
              <el-col :span="8">
                <el-input v-model="formData.real_name"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="客服城市" :label-width="formLabelWidth">
              <el-col :span="8">
                <el-select v-model="formData.city_flag" filterable placeholder="请选择" style="margin-right: 20px">
                  <el-option v-for="item in cityOptions" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                </el-select>
              </el-col>
            </el-form-item>
            <el-form-item label="具体城市" :label-width="formLabelWidth" v-if="formData.city_flag === 2">
              <el-col :span="8">
                <el-select v-model="formData.city_name" filterable placeholder="山东客服必须选择新泰或济宁" style="margin-right: 20px">
                  <el-option label="新泰" value="新泰"></el-option>
                  <el-option label="济宁" value="济宁"></el-option>
                </el-select>
              </el-col>
            </el-form-item>
            <el-form-item label="客服类型" :label-width="formLabelWidth">
              <el-col :span="8">
                <el-select v-model="formData.group_type" filterable placeholder="请选择" style="margin-right: 20px">
                  <el-option v-for="item in customerServiceTypeOptions" :key="item.name" :label="item.name" :value="item.id"> </el-option>
                </el-select>
              </el-col>
            </el-form-item>
            <el-form-item label="VIP组别" :label-width="formLabelWidth" v-if="checkVip">
              <el-col :span="8">
                <el-select v-model="formData.vip_type" filterable placeholder="请选择" style="margin-right: 20px">
                  <el-option v-for="item in vipOptions" :key="item.name" :label="item.name" :value="item.id"> </el-option>
                </el-select>
              </el-col>
            </el-form-item>
            <el-form-item label="电话" :label-width="formLabelWidth">
              <el-col :span="8">
                <el-input v-model="formData.mobile"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="邮箱" :label-width="formLabelWidth">
              <el-col :span="8">
                <el-input v-model="formData.email"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="角色" :label-width="formLabelWidth">
              <el-col :span="8">
                <el-select v-model="formData.role_ids" multiple filterable placeholder="请选择">
                  <el-option v-for="item in roleOptions" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                </el-select>
              </el-col>
            </el-form-item>
            <el-form-item label="" :label-width="formLabelWidth">
              <el-col :span="24">
                <el-radio v-model="addPower" label="1">另加权限</el-radio>
                <el-radio v-model="addPower" label="0">不加权限</el-radio>
              </el-col>
            </el-form-item>
            <el-form-item label="权限" :label-width="formLabelWidth" v-if="this.addPower == 1">
              <el-col :span="24">
                <div class="transfer">
                  <div class="left box">
                    <el-tree ref="tree" node-key="id" :default-expand-all="true" :props="props" :data="formData.role_data_left" show-checkbox></el-tree>
                  </div>
                  <div class="buttons">
                    <div>
                      <el-button icon="el-icon-arrow-right" @click="toRight" type="primary" circle></el-button>
                    </div>
                    <div>
                      <el-button icon="el-icon-arrow-left" @click="toLeft" type="primary" circle></el-button>
                    </div>
                  </div>
                  <div class="right box">
                    <el-checkbox-group ref="checkGroup" @change="checkBoxGroupChange" v-model="formData.checkList">
                      <el-checkbox v-for="(item, idx) in formData.role_data_right" :key="idx" :value="item" :checked="item.isChecked" :label="item.node.description"></el-checkbox>
                    </el-checkbox-group>
                  </div>
                </div>
              </el-col>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="removePower">取 消</el-button>
            <el-button type="primary" @click="handleCreateUpdateStore">确 定</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import BindDD from '@/components/common/BindDD';
import {
  userListApi,
  getAdminCityApi,
  getRoleListApi,
  resetPasswordApi,
  setUserStatusApi,
  deleteUserApi,
  getPermissionTreeApi,
  getEditUserApi,
  getUserPermissionsApi,
  putEditUserApi,
  addUserApi,
} from '@/api/new_admin_user.js';
import Pagination from '@/components/pagination/index';

export default {
  components: {
    Pagination,
    BindDD,
  },
  name: 'newUser',
  data() {
    return {
      // 权限转移的 参数
      props: {
        label: 'description',
        children: 'children',
      },
      // 列表
      listLoading: false,
      total: 0,
      tableData: [],
      listQuery: {
        name: '',
        real_name: '',
        role: '',
        user_status: '',
        create_time: '',
        page: 1,
        limit: 10,
      },
      roleOptions: [],
      statusOptions: [
        {
          name: '正常',
          id: '1',
        },
        {
          name: '禁用',
          id: '0',
        },
      ],
      // 表单
      dialogFormVisible: false,
      passwordVisible: false,
      formData: {
        id: '',
        name: '', // 添加使用
        password: '', // 添加
        real_name: '',
        email: '',
        mobile: '',
        city_flag: '',
        city_name: '',
        group_type: '',
        role_ids: [],
        permission_ids: [],
        vip_type: '',
        // 表单权限的设定
        checkList: [],
        role_data_left: [],
        role_data_right: [],
      },
      rightCheckeds: [],
      userPower: [],
      addPower: 0,
      mode: 'transfer',

      // vip分组
      vipShow: false,
      vipOptions: [],

      // 客服
      cityOptions: [],
      customerServiceTypeOptions: [],

      formLabelWidth: '120px',
      formInputWidth: '200px',
      check: 0,

      // 重置
      resetShow: false,
      resetID: '',
      // 禁用
      banId: '',
      operation: '',
      disabText: '',
      disableShow: false,
      // 删除
      deleteShow: false,
      delID: '',
    };
  },
  created() {
    this.userList();
    this.getAdminCity();
    this.getRoleList();
  },
  computed: {
    checkVip() {
      // 杭州  vip
      let arr = false;
      if (this.formData.city_flag == 1 && this.formData.group_type == 2) {
        this.vipOptions = [];
        for (let i = 0; i < 4; i++) {
          let item = {};
          item.name = 'vip' + (i + 1);
          item.id = i + 1;
          this.vipOptions.push(item);
        }
        arr = true;
      }
      // 山东  vip
      if (this.formData.city_flag == 2 && this.formData.group_type == 2) {
        this.vipOptions = [];
        for (let i = 0; i < 3; i++) {
          let item = {};
          item.name = 'vip' + (i + 1);
          item.id = i + 1;
          this.vipOptions.push(item);
        }
        arr = true;
      }
      // 新疆  vip
      if (this.formData.city_flag == 3 && this.formData.group_type == 2) {
        this.vipOptions = [];
        for (let i = 0; i < 1; i++) {
          let item = {};
          item.name = 'vip' + (i + 1);
          item.id = i + 1;
          this.vipOptions.push(item);
        }
        arr = true;
      }
      return arr;
    },
  },
  methods: {
    handleBind(row) {
      this.$refs.bind.bindAcc(row.id);
    },
    userList() {
      this.listLoading = true;
      userListApi(this.listQuery)
        .then((response) => {
          const data = response.data.data;
          this.listLoading = false;
          let array = [];
          for (let item of response.data.data.data) {
            if (item.user_status == 1) {
              item.user_status_name = '正常';
            } else if (item.user_status == 0) {
              item.user_status_name = '禁用';
            }
            if (item.city_flag == 1) {
              item.city_flag = '杭州 ';
            } else if (item.city_flag == 2) {
              item.city_flag = '山东';
            } else if (item.city_flag == 3) {
              item.city_flag = '新疆';
            } else {
              item.city_flag = '';
            }
            if (item.group_type == 1) {
              item.group_type = '普客组';
            } else if (item.group_type == 2) {
              item.group_type = 'VIP组';
            } else {
              item.group_type = '';
            }
          }
          this.tableData = response.data.data.data;
          this.total = response.data.data.total;
        })
        .catch((error) => {
          this.listLoading = false;
        });
    },
    getAdminCity() {
      getAdminCityApi()
        .then((response) => {
          this.cityOptions = response.data.data.city.map((item) => {
            return {
              ...item,
              id: Number(item.id),
            };
          });
          this.customerServiceTypeOptions = response.data.data.group.map((item) => {
            return {
              ...item,
              id: Number(item.id),
            };
          });
        })
        .catch((error) => {});
    },
    getRoleList() {
      getRoleListApi()
        .then((response) => {
          this.roleOptions = response.data.data;
        })
        .catch((error) => {});
    },
    getPermissionTree() {
      getPermissionTreeApi()
        .then((response) => {
          this.formData.role_data_left = response.data.data;
        })
        .catch((error) => {});
    },
    getUserPermissions(data) {
      let m = {
        id: '',
      };
      m.id = data.id;
      getUserPermissionsApi(m)
        .then((response) => {
          this.formData.role_data_right = [];
          for (let item of response.data.data) {
            let a = {
              node: {},
              isChecked: false,
            };
            a.node.id = item.id;
            a.node.description = item.description;
            this.formData.role_data_right.push(a);
          }
          if (this.formData.role_data_right.length != 0) {
            this.addPower = 1;
          } else if (this.formData.role_data_right.length == 0) {
            this.addPower = 0;
          }
        })
        .catch((error) => {});
    },
    handleUserRoleList(row) {
      handleUserRoleListApi(row)
        .then((response) => {
          const data = response.data.data;
          this.userList();
        })
        .catch((error) => {});
    },
    handlePermissionList() {
      handlePermissionListApi()
        .then((response) => {
          const data = response.data.data;
          this.formData.permission_data_left = data;
        })
        .catch((error) => {});
    },
    handleUserPermissionList(row) {
      handleUserPermissionListApi(row)
        .then((response) => {
          const data = response.data.data;
          this.formData.permission_data_right = data;
        })
        .catch((error) => {});
    },

    // 权限转移的函数
    getExpandTreeData(tree_data) {
      let arr = [];
      let expandTree = function (data) {
        arr.push(data);
        if (data.children && data.children.length) {
          data.children.forEach((item) => {
            expandTree(item);
          });
        }
      };
      tree_data.forEach((item) => {
        expandTree(item);
      });
      return arr;
    },
    checkBoxGroupChange() {
      let checkBoxs = this.$refs.checkGroup.$children;
      this.rightCheckeds = [];
      checkBoxs.forEach((item) => {
        if (item.isChecked) {
          // 这里的 value 指代的就是被选中的数据。
          this.rightCheckeds.push(item.value);
        }
      });
    },
    toRight() {
      let res = this.$refs.tree.getCheckedNodes(true);
      let arr = [];
      let parent = [];
      let expandNodes = this.getExpandTreeData(this.$refs.tree.data);
      res.forEach((item) => {
        let current = {
          node: item,
          parent: null,
          isChecked: false,
        };
        // 找到父节点
        expandNodes.forEach((parent) => {
          if (parent.id == item.pid) {
            current.parent = parent;
          }
        });
        let copyCheck = 0;
        for (let item of this.formData.role_data_right) {
          if (item.node.id == current.node.id) {
            copyCheck = 1;
          }
        }
        if (current.node.id == 147) {
          copyCheck = 1;
        }
        if (copyCheck == 0) {
          this.formData.role_data_right.push(current);
        }
      });
    },
    toLeft() {
      this.rightCheckeds.forEach((checkedNode) => {
        this.formData.role_data_right.forEach((item, idx) => {
          if (item.node.id === checkedNode.node.id) {
            // 检查parent是否在右边.如果在,则先添加parent节点
            this.formData.role_data_right.splice(idx, 1);
            // this.formData.role_data_right.forEach((item2,idx2) => {
            //     if (item.parent && item2.node.id === item.parent.id) {
            //         this.$refs.tree.append(
            //             item2.node,
            //             (item2.parent && item2.parent.id) ||
            //                 undefined
            //         );
            //         this.formData.role_data_right.splice(idx2, 1);
            //     }
            // });
            // this.$refs.tree.append(
            //     item.node,
            //     (item.parent && item.parent.id) || undefined
            // );
            this.formData.role_data_right.splice(idx, 1);
          }
        });
      });
    },

    handleResetForm() {
      this.formData.account = '';
      this.formData.password = '';
      this.formData.name = '';
      this.formData.mobile = '';
      this.formData.real_name = '';
      this.formData.email = '';
      this.formData.city_flag = '';
      this.formData.city_name = '';
      this.formData.vip_type = '';
      this.formData.group_type = '';
      this.formData.role_data_right = [];
      this.formData.role_ids = [];
      this.formData.permission_data_right = [];
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.userList(this.listQuery);
    },
    handleCreate() {
      this.formData.checkList = [];
      this.formData.role_data_right = [];
      this.addPower = 0;
      this.getPermissionTree();
      this.handleResetForm();
      this.passwordVisible = true;
      this.dialogFormVisible = true;
      this.vipShow = false;
      this.check = 1;
    },
    handleReset() {
      this.listQuery.name = '';
      this.listQuery.role = '';
      this.listQuery.real_name = '';
      this.listQuery.user_status = '';
      this.listQuery.create_time = [];
      this.listQuery.page = 1;
      this.listQuery.limit = 10;
      this.userList(this.listQuery);
    },
    removePower() {
      this.dialogFormVisible = false;
    },
    handleCreateUpdateStore() {
      if (this.formData.city_flag === 2 && !this.formData.city_name) {
        this.$message.error('请选择具体城市（新泰/济宁）');
        return;
      }
      if (this.check == 2) {
        let data = [];
        for (let item of this.formData.role_data_right) {
          data.push(item.node.id);
        }
        this.formData.permission_ids = data;
        let array = {};
        array.name = this.formData.name;
        array.id = this.formData.id;
        array.real_name = this.formData.real_name;
        array.mobile = this.formData.mobile;
        array.email = this.formData.email;
        array.role_ids = this.formData.role_ids;
        array.city_flag = this.formData.city_flag;
        array.city_name = this.formData.city_name;
        array.group_type = this.formData.group_type;
        array.vip_type = this.formData.vip_type;
        array.permission_ids = this.formData.permission_ids;
        if (this.checkVip == false) {
          this.$delete(array, 'vip_type');
        }
        putEditUserApi(array)
          .then((response) => {
            if (response.data.code == 200) {
              this.$message.success(response.data.message);
              this.dialogFormVisible = false;
              this.userList(this.listQuery);
            } else {
              this.$message.error(response.data.message);
            }
          })
          .catch((error) => {});
      } else if (this.check == 1) {
        let data = {};
        data.name = this.formData.name;
        data.password = this.formData.password;
        data.real_name = this.formData.real_name;
        data.mobile = this.formData.mobile;
        data.email = this.formData.email;
        data.role_ids = this.formData.role_ids;
        data.city_flag = this.formData.city_flag;
        data.city_name = this.formData.city_name;
        data.group_type = this.formData.group_type;
        data.vip_type = this.formData.vip_type;
        let arr = [];
        for (let item of this.formData.role_data_right) {
          arr.push(item.node.id);
        }
        this.formData.permission_ids = arr;
        data.permission_ids = this.formData.permission_ids;
        if (this.checkVip == false) {
          this.$delete(data, 'vip_type');
        }
        addUserApi(data)
          .then((response) => {
            if (response.data.code == 200) {
              this.$message.success(response.data.message);
              this.dialogFormVisible = false;
              this.userList(this.listQuery);
            } else {
              this.$message.error(response.data.message);
            }
          })
          .catch((error) => {});
      }
    },
    handleUpdate(row) {
      this.formData.checkList = [];
      this.handleResetForm();
      this.check = 2;
      let data = {
        id: '',
      };
      data.id = row.id;
      this.getUserPermissions(row);
      this.getPermissionTree();
      getEditUserApi(data)
        .then((response) => {
          this.formData.role_ids = response.data.data.role_ids;
          this.formData.vip_type = response.data.data.vip_type;
          this.formData.city_flag = Number(response.data.data.city_flag);
        this.formData.city_name = response.data.data.city_name || '';
          this.formData.group_type = Number(response.data.data.group_type);
        })
        .catch((error) => {});
      this.dialogFormVisible = true;
      this.passwordVisible = false;
      this.formData.id = row.id;
      this.formData.name = row.name;
      this.formData.email = row.email;
      this.formData.mobile = row.mobile;
      this.formData.real_name = row.real_name;
      let roleName = '';
      this.userList();
    },
    resetUserPassword(item) {
      this.resetID = item.id;
      this.resetShow = true;
    },
    sureReset() {
      let data = { id: '' };
      data.id = this.resetID;
      resetPasswordApi(data)
        .then((response) => {
          if (response.data.code == 200) {
            this.$message.success(response.data.message);
            this.resetShow = false;
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch((error) => {});
    },
    disableAccount(item) {
      if (item.user_status == 1) {
        this.operation = 0;
        this.disabText = '确认禁用此角色权限？';
      } else if (item.user_status == 0) {
        this.operation = 1;
        this.disabText = '确认恢复此角色权限？';
      }
      this.banId = item.id;
      this.disableShow = true;
    },
    sureDisable() {
      let data = {
        id: '',
        operation: '',
      };
      data.id = this.banId;
      data.operation = this.operation;
      setUserStatusApi(data)
        .then((response) => {
          if (response.data.code == 200) {
            this.disableShow = false;
            this.$message.success(response.data.message);
            this.userList();
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch((error) => {});
    },
    removeDisable() {
      this.disableShow = false;
    },
    userDelete(item) {
      this.deleteShow = true;
      this.delID = item.id;
    },
    handleDelete() {
      deleteUserApi({ id: this.delID })
        .then((response) => {
          if (response.data.code == 200) {
            this.$message.success(response.data.message);
            this.deleteShow = false;
            this.userList(this.listQuery);
          } else {
            this.deleteShow = false;
            this.$message.error(response.data.message);
          }
        })
        .catch((error) => {});
    },
  },
};
</script>
<style scoped>
div.el-transfer .el-transfer-panel {
  width: 400px;
}
</style>
<style lang="less" scoped>
.transfer {
  display: flex;
  flex-direction: row;

  .box {
    width: 250px;
    border: 1px solid #ccc;
    padding: 20px;
    height: 500px;
    overflow: auto;
    box-sizing: border-box;
  }

  .buttons {
    margin-top: 30%;
    display: flex;
    flex-direction: column;
  }

  .right .el-checkbox-group {
    display: flex;
    flex-direction: column;
  }
}
</style>